import * as Yup from "yup";

const errors = {
  projectType: "Please select a project type",
  projectAs: "Please select project as value",
  budgetRange: "Please select budget range",
  timelineProject: "Please select timeline project",
  projectLocation: "Please enter project location",
  customerName: "Please enter customer name",
  customerEmail: "Please enter valid email address",
  phoneNumberRequired: "Please enter phone number",
  agreeTerms: "Please select privacy policy",
  captchaToken: "Please verify the captcha",
  phoneNumberInvalid: "Please enter a valid phone number",
  phoneNumberFormat: "Phone number can only contain digits",
  submitGeneric:
    "An error occurred while submitting the form. Please try again later.",
};

export const brandRegistrationValidation = Yup.object().shape({
  projectType: Yup.array()
    .min(1, errors.projectType)
    .required(errors.projectType),

  projectAs: Yup.string().trim().required(errors.projectAs),

  budgetRange: Yup.string().trim().required(errors.budgetRange),

  timelineProject: Yup.string().trim().required(errors.timelineProject),

  projectLocation: Yup.string().trim().required(errors.projectLocation),

  customerName: Yup.string().trim().required(errors.customerName),

  customerEmail: Yup.string()
    .trim()
    .email(errors.customerEmail)
    .required(errors.customerEmail),

  phoneNumber: Yup.string()
    .trim()
    .matches(/^[0-9+]+$/, errors.phoneNumberFormat)
    .matches(
      /^(\+84|84|0)?[3|5|7|8|9][0-9]{8}$|^(\+62|62|0)?8[0-9]{8,11}$|^(\+91|91)?[6-9][0-9]{9}$/,
      errors.phoneNumberInvalid
    )
    .required(errors.phoneNumberRequired),

  agreeTerms: Yup.boolean()
    .oneOf([true], errors.agreeTerms)
    .required(errors.agreeTerms),

  agreeMarketing: Yup.boolean().notRequired(),

  captchaToken: Yup.string().trim().nullable().required(errors.captchaToken),
});
